import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './TopBar.css';
import logo from '../assets/logo.png';
import { useAuth } from '../auth/AuthContext';
import { usePage } from '../content/PageContext';

const TopBar = () => {
    const [activeSection, setActiveSection] = useState('');
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [accountOpen, setAccountOpen] = useState(false);
    const { user, isAdmin, logout } = useAuth();
    const { page } = usePage();
    const navigate = useNavigate();

    const navItems = (page.nav || []).filter((n) => n.visible !== false);

    const handleScroll = () => {
      const ids = navItems.map((n) => n.id);
      let currentSection = '';
      ids.forEach(id => {
        const el = document.getElementById(id);
        if (!el) return;
        const rect = el.getBoundingClientRect();
        if (rect.top <= window.innerHeight / 2 && rect.bottom >= window.innerHeight / 2) {
          currentSection = id;
        }
      });
      setActiveSection(currentSection);
    };

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
      };

    const handleMenuClick = (sectionId) => {
      setIsMenuOpen(false);
      setActiveSection(sectionId);
    };

    const go = (path) => {
      setAccountOpen(false);
      setIsMenuOpen(false);
      navigate(path);
    };

    useEffect(() => {
      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page.nav]);

    return (
        <div className="top-bar">
          <img src={logo} alt="Logo" className="logo" />
          <div className='menu'>
          <button className="hamburger" onClick={toggleMenu}>☰</button>
            <nav className={`nav-menu ${isMenuOpen ? 'open' : ''}`}>
                <ul>
                  {navItems.map((n) => (
                    <li key={n.id}>
                      <a href={'#' + n.id} className={activeSection === n.id ? 'active' : ''} onClick={() => handleMenuClick(n.id)}>{n.label}</a>
                    </li>
                  ))}
                  {user ? (
                    <li className="account-menu">
                      <button className="nav-btn" onClick={() => setAccountOpen(!accountOpen)}>
                        {user.email.split('@')[0]} ▾
                      </button>
                      {accountOpen && (
                        <div className="account-dropdown">
                          <button className="account-item" onClick={() => go('/account')}>账户</button>
                          <button className="account-item" onClick={() => go('/videos')}>视频</button>
                          {isAdmin && <button className="account-item" onClick={() => go('/admin')}>管理</button>}
                          <button className="account-item" onClick={() => { setAccountOpen(false); logout(); }}>退出</button>
                        </div>
                      )}
                    </li>
                  ) : (
                    <li><button className="nav-btn" onClick={() => navigate('/login')}>登录</button></li>
                  )}
                </ul>
            </nav>
          </div>
        </div>
      );
    };

export default TopBar;
